import { render, staticRenderFns } from "./BookOrdersToCarrierModal.vue?vue&type=template&id=64137d1e&scoped=true&"
import script from "./BookOrdersToCarrierModal.vue?vue&type=script&lang=js&"
export * from "./BookOrdersToCarrierModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64137d1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64137d1e')) {
      api.createRecord('64137d1e', component.options)
    } else {
      api.reload('64137d1e', component.options)
    }
    module.hot.accept("./BookOrdersToCarrierModal.vue?vue&type=template&id=64137d1e&scoped=true&", function () {
      api.rerender('64137d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/BookOrdersToCarrierModal.vue"
export default component.exports